// A2F-803: NDA Reviewers Guide pack rule definitions.
//
// One ScanRule ships in v0 against the new document-target executor
// primitive (`document.hasInlineToc`). The other four originally-scoped
// rules (outline format, hyperlink count, PED table, not-mostly-
// narrative) are deferred until their heuristics are firmer — per the
// "ship one confident rule, validate in dev, iterate later" plan-round
// decision on the T4 ticket. New rules join here, in the same
// per-rule-export shape as ind-pack-rules / ectd-pack-rules.
//
// Pack-only — not added to TAG_RULES; discoverability is via the
// NDA Reviewers Guide pack toggle in /configure and My Chrona.

import type { ScanRule } from '../types'

// FDA reviewers expect a Reviewer's Guide that links to the supporting
// submission components, not one that carries a copy-pasted snapshot
// of the Backbone table of contents. Inline TOCs (5+ consecutive
// paragraphs in `Title\t…\tPageNumber` shape, in non-TOC styles)
// are the telltale of a pasted-as-text submission TOC carried over
// from an early-draft outline; the executor's
// `computeDocumentAggregates` walks the body once and exposes
// `document.hasInlineToc` so this rule fires at most once per scan.
//
// MANUAL-VERIFY: confirm a real Word auto-generated TOC (Insert →
// Table of Contents) does NOT trip this rule on the installed Word
// build — the executor relies on Word's built-in `TOC 1`/`TOC 2`/…
// paragraph styles being attached to auto-TOC entries. A document
// with a pasted-as-text TOC SHOULD fire it.
export const nda_reviewers_guide_no_backbone_toc: ScanRule = {
  id: 'nda_reviewers_guide_no_backbone_toc',
  type: 'scan',
  tier: 'pro',
  privacy: 'local',
  label: 'No pasted backbone TOC',
  icon: 'list',
  description:
    "Flag a Reviewer's Guide that carries a pasted-as-text submission TOC instead of inline cross-references.",
  targets: ['document'],
  conditions: [
    { property: 'document.hasInlineToc', operator: 'equals', value: true },
  ],
  conditionLogic: 'any',
  action: 'flag',
  severity: 'warn',
  message:
    "This Reviewer's Guide appears to contain a pasted-as-text table of contents. Replace it with inline cross-references to the linked submission sections.",
}

export const REVIEWERS_GUIDE_PACK_RULES = [
  nda_reviewers_guide_no_backbone_toc,
] as const
